import { FunctionComponent, PropsWithChildren } from 'react'

import { Icons, SlideInRightView } from 'atoms'
import { Box, Button, Heading, Text, VStack, HStack } from 'native-base'
import { Dimensions, ImageBackground } from 'react-native'

type ErrorLayoutProps = {
  description?: string
  handleActionButton?: () => void
  nameActionButton?: string
  title?: string
}

export const ErrorLayout: FunctionComponent<PropsWithChildren<ErrorLayoutProps>> = ({
  children,
  description,
  handleActionButton,
  nameActionButton,
  title
}) => {
  return (
    <Box flex={1} bg="white">
      <HStack w="100%" h="100%" maxW={1600} position="relative" alignItems="center" mx="auto">
        <VStack w="639px" maxW="639px" bg="gray.50" rounded={32} p={10}>
          <Box>
            <Icons.LogoTurbo color="gray.700" size={112} />
          </Box>
          <VStack flex={1} mx="auto" w="full" justifyContent="center" pt="160px">
            <Heading color="gray.700" fontSize="24px" lineHeight="38px" mb="12px">
              {title}
            </Heading>
            <Text color="gray.500" fontSize="21px" lineHeight="30px" mb="25px">
              {description}
            </Text>
            <Button colorScheme="gray" onPress={handleActionButton} w="full" marginBottom="auto">
              {nameActionButton}
            </Button>
          </VStack>
        </VStack>
        <VStack w="45%" flex={1} position="relative" alignItems="flex-end">
          <SlideInRightView style={{ position: 'relative', flex: 1, alignItems: 'flex-end' }}>
            <ImageBackground
              source={require('assets/external-layout-image.png')}
              resizeMode="cover"
              style={{
                width: 600,
                height: Dimensions.get('window').height
              }}
            />
          </SlideInRightView>
        </VStack>
      </HStack>
    </Box>
  )
}
